export default __webpack_public_path__ + "static/media/UAE.e3b5eb0b.svg";